import type { CredentialStatus } from '../types';

export const UFS = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
export const WEEKDAYS = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
export const WEEKDAYS_SHORT = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

/** Stepper do onboarding (copy exata do mock). */
export const ONBOARDING_STEPS = ['Identificação', 'Certificado digital', 'Papéis e especialidades', 'Faturamento e Pix', 'Contrato', 'Aprovação'];
export const stepPath = (n: number) => (n >= 6 ? '/medico/credenciamento/status' : `/medico/credenciamento/passo/${n}`);

/** Texto do chip de status (T-27/T-32). */
export const CREDENTIAL_LABEL: Record<CredentialStatus, { text: string; tone: 'ok' | 'warn' | 'bad' | 'info' }> = {
  ONBOARDING: { text: 'Cadastro em preenchimento', tone: 'info' },
  AWAITING_MANAGER: { text: 'Aguardando aprovação do gestor Azanas', tone: 'warn' },
  REJECTED: { text: 'Pendente de correção', tone: 'bad' },
  APPROVED_AWAITING_FINANCE: { text: 'Aprovado — aguardando o financeiro', tone: 'warn' },
  RELEASED: { text: 'Cadastro aprovado pelo gestor · credenciado', tone: 'ok' },
  BLOCKED: { text: 'Bloqueado pelo gestor', tone: 'bad' },
};

export const isEnvironmentStatus = (s?: string | null) => s === 'RELEASED' || s === 'BLOCKED';
